export default __webpack_public_path__ + "static/media/Cvl_logo.931434b1.svg";